import { createAction } from "redux-actions";

export const getResults = createAction("GET_RESULTS");
export const getResultsSuccess = createAction("GET_RESULTS_SUCCESS");
export const getResultsError = createAction("GET_RESULTS_ERROR");
export const setResultsLoaded = createAction("GET_RESULTS_LOADED");
